// src/services/contactService.ts
import apiClient from "./apiClient";

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export const sendContactMessage = async (
  formData: ContactFormData
): Promise<void> => {
  try {
    await apiClient.post("/contact-us", formData);
  } catch (error) {
    console.error("Failed to send contact message:", error);
    throw new Error("Failed to send message. Please try again later.");
  }
};
